window.dataLayer = window.dataLayer || [];
export const dataLayerPushEvent = (eventName) => {
  window.dataLayer.push({ event: eventName });
};
